<template>
    <div>
        <section class="container mt-3 py-3">
            <!-- COMPONENTE DE BOTONES QUE SE MUESTRAN -->
            <h4>Botones Generales</h4>
            <div class="my-2 d-flex flex-wrap">
                <vs-button class="btn-primary">Primary</vs-button>
                <vs-button class="btn-primary-variant">Primary variant</vs-button>
                <vs-button class="btn-secondary">Secundary</vs-button>
                <vs-button class="btn-secondary-variant">Secundary variant</vs-button>
                <vs-button class="btn-tertiary">Tertiary</vs-button>
                <vs-button class="btn-tertiary-variant">Tertiary variant</vs-button>
            </div>
            <div class="my-2 d-flex">
                <!-- <vs-button square class="btn-warning">Warning</vs-button> -->
                <vs-button class="btn-success">Success</vs-button>
                <vs-button class="btn-danger">Danger</vs-button>
            </div>
            
            <vs-button class="btn-transparent">Transparent</vs-button>

<!--  -->
        <p class="text-dark mt-4 mb-1">Clases de estilos (colores).</p>
        <code>
            .btn-primary <br>
            .btn-primary-variant <br>
            .btn-secondary <br>
            .btn-secondary-variant <br>
            .btn-tertiary <br>
            .btn-tertiary-variant <br>
            .btn-success <br>
            .btn-danger <br>
            .btn-transparent
        </code>
        <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación de botones</p>
        <!-- CODIGO HTML -->
        <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-button class="btn-primary"> btn-primary </vs-button>
<vs-button class="btn-secondary"> btn-secondary </vs-button>
<vs-button class="btn-tertiary"> btn-tertiary </vs-button>
</script></code></pre>
        </div>
        <!-- CODIGO HTML -->
<!--  -->
            <!-- <p class="text-dark my-0"><i class="fa-brands fa-html5 _html"></i> Clases para la implementación de botones</p>
          
        <pre><textarea style="height:230px;" readonly>
            <vs-button class="btn-primary">Primary</vs-button>
            <vs-button class="btn-primary-variant">Primary variant</vs-button>
            <vs-button class="btn-secondary">Secundary</vs-button>
            <vs-button class="btn-secondary-variant">Secundary variant</vs-button>
            <vs-button class="btn-tertiary">Tertiary</vs-button>
            <vs-button class="btn-tertiary-variant">Tertiary variant</vs-button>
            
            <vs-button class="btn-success">Success</vs-button>
            <vs-button class="btn-danger">Danger</vs-button>
            
            <vs-button class="btn-transparent">Transparent</vs-button></textarea></pre>
            <code>
                .btn-primary <br>
                .btn-primary-variant <br>
                .btn-secondary <br>
                .btn-secondary-variant <br>
                .btn-tertiary <br>
                .btn-tertiary-variant <br>
                .btn-success <br>
                .btn-danger <br>
                .btn-transparent
            </code> -->
        </section>


        <!-- Botones con borde/outline -->
        <section class="container my-5">
            <h4>Botones Generales Outline</h4>
            <div class="my-2 d-flex flex-wrap">
                <vs-button class="btn-primary-o">Primary</vs-button>
                <vs-button class="btn-primary-variant-o">Primary variant</vs-button>
                <vs-button class="btn-secondary-o">Secundary</vs-button>
                <vs-button class="btn-secondary-variant-o">Secundary variant</vs-button>
                <vs-button class="btn-tertiary-o">Tertiary</vs-button>
                <vs-button class="btn-tertiary-variant-o">Tertiary variant</vs-button>
            </div>
            <div class="my-2 d-flex">
                <vs-button class="btn-success-o">Success</vs-button>
                <vs-button class="btn-danger-o">Danger</vs-button>
            </div>
        
            <!-- <p class="text-dark my-0"><i class="fa-brands fa-html5 _html"></i> Clases para la implementación de botones bordeados</p>
        <pre><textarea style="height:191px;" readonly>
            <vs-button class="btn-primary-o">Primary</vs-button>
            <vs-button class="btn-primary-variant-o">Primary variant</vs-button>
            <vs-button class="btn-secondary-o">Secundary</vs-button>
            <vs-button class="btn-secondary-variant-o">Secundary variant</vs-button>
            <vs-button class="btn-tertiary-o">Tertiary</vs-button>
            <vs-button class="btn-tertiary-variant-o">Tertiary variant</vs-button>

            <vs-button class="btn-success-o">Success</vs-button>
            <vs-button class="btn-danger-o">Danger</vs-button></textarea></pre> -->
            <code>
                .btn-primary-o <br>
                .btn-primary-variant-o <br>
                .btn-secondary-o <br>
                .btn-secondary-variant-o <br>
                .btn-tertiary-o <br>
                .btn-tertiary-variant-o <br>
                .btn-success-o <br>
                .btn-danger-o
            </code>
            <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación de botones bordeados</p>
            <!-- CODIGO HTML -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-button class="btn-primary-o"> btn-primary-o </vs-button>
<vs-button class="btn-secondary-o"> btn-secondary-o </vs-button>
<vs-button class="btn-tertiary-o"> btn-tertiary-o </vs-button>
</script></code></pre>
            </div>
            <!-- CODIGO HTML -->    
        </section>


        <!-- tamaños de botones -->
        <section class="my-5">
            <h4>Tamaño o medida de botones</h4>
            <p class="text-dark my-0"> Clases que especifican tamaño a los botones</p>
            <div class="d-flex flex-wrap align-items-end">
                <vs-button class="btn-primary large">Large button</vs-button>
                <vs-button class="btn-primary">Default button</vs-button>
                <vs-button class="btn-primary small">Small button</vs-button>
                <vs-button class="btn-primary mini">Extra small button</vs-button>
            </div>
                <!-- <pre><textarea style="height:95px;" readonly>
            <vs-button class="btn-primary large">Large button</vs-button>
            <vs-button class="btn-primary">Default button</vs-button>
            <vs-button class="btn-primary small">Small button</vs-button>
            <vs-button class="btn-primary mini">Extra small button</vs-button></textarea></pre> -->
            <code>
                .large <br>
                .small <br>
                .mini
            </code>
            <!-- <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación de botones bordeados</p> -->
            <!-- CODIGO HTML -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-button class="btn-primary large"> Large button </vs-button>
<vs-button class="btn-primary"> Default button </vs-button>
<vs-button class="btn-primary small"> Small button </vs-button>
<vs-button class="btn-primary mini"> Extra small button </vs-button>
</script></code></pre>
            </div>
            <!-- CODIGO HTML -->
        </section>
        <!-- Botones desplegables -->     
        <section class="my-5">
            <h4>Botones "Dropdowns"</h4>
            <p class="text-dark my-0"> Clases para botones desplegables.</p>
            <div class="d-flex flex-wrap align-items-end">
                <!-- botón dropdown -->
                <div class="btn-group dropdown">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropdown </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #1</li>
                        <li class="dropdown-item">Opcion #2</li>
                    </ul>
                </div>
                <!-- botón dropup -->
                <div class="btn-group dropup">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropup </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #3</li>
                        <li class="dropdown-item">Opcion #4</li>
                    </ul>
                </div>
                <!-- botón drop end -->
                <div class="btn-group dropend">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary dropdown-toggle" aria-expanded="false">          
                Dropdend </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #5</li>
                        <li class="dropdown-item">Opcion #6</li>
                    </ul>
                </div>
                <!-- botón dropstart -->
                <div class="btn-group dropstart">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropstart </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #7</li>
                        <li class="dropdown-item">Opcion #8</li>
                    </ul>
                </div>
            </div>
            <code>
                .dropdown <br>
                .dropup <br>
                .dropend <br>
                .dropstart <br>
            </code>

            <p class="text-dark mt-4 mb-1">Codigo de ejemplo. <br>
                (Para darle sentido al menú, a la derecha, izquierda, arriba o abajo, basta con cambiar unicamente la clase del div contenedor).
            </p>
            <!-- CODIGO HTML -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><div class="dropdown">
    <vs-button class="btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
        Dropdown
    </vs-button>
    <ul class="dropdown-menu">
        <li class="dropdown-item">Opcion #1</li>
        <li class="dropdown-item">Opcion #2</li>
    </ul>
</div>
</script></code></pre>
            </div>            
            <!-- CODIGO HTML -->

            <h4 class="mt-4">Combinaciones de los botones</h4>
            <p class="text-dark my-0"> Se pueden poner diferentes estilos a los botones, usando las clases anteriormente mencionadas.</p>
            <div class="d-flex flex-wrap align-items-end">
                <!-- botón dropdown -->
                <div class="btn-group dropdown">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary large dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropdown </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #1</li>
                        <li class="dropdown-item">Opcion #2</li>
                    </ul>
                </div>
                <!-- botón dropup -->
                <div class="btn-group dropup">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary-o  dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropup </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #3</li>
                        <li class="dropdown-item">Opcion #4</li>
                    </ul>
                </div>
                <!-- botón dropend -->
                <div class="btn-group dropend">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-primary-variant small dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropdend </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #5</li>
                        <li class="dropdown-item">Opcion #6</li>
                    </ul>
                </div>
                <!-- botón dropstart -->
                <div class="btn-group dropstart">
                    <vs-button data-bs-toggle="dropdown" type="button" class="btn-secondary-variant-o mini dropdown-toggle" aria-haspopup=""  aria-expanded="false">          
                Dropstart </vs-button>
                    <ul class="dropdown-menu py-1">
                        <li class="dropdown-item">Opcion #7</li>
                        <li class="dropdown-item">Opcion #8</li>
                    </ul>
                </div>
            </div>
                
        </section>
    </div>
</template>



<script>
export default {
    created(){
        window.scrollTo(0, 0);
    },
    data:function(){
        return{

            htmlvalue: ' <vs-button class="',
            htmlvalue1:'<vs-button data-bs-toggle="',
            htmlvalue2: '</vs-button>',

            htmldropdown: '<div class="',
            htmldropdown1:'</div>',
            htmldropdown2:'<ul class="dropdown-menu">',
            htmldropdown3:'</ul>',
            htmldropdown4:'<li class="dropdown-item">Opcion #1</li>',
            htmldropdown5:'</li>',  
            // htmlvalue3: '<label class="labelTextarea" for="TextareaName">Ingrese su comentario</label>',
        }
    }
}
</script>